import { Box, Spinner } from '@ui';

export const VideoGridLoading = () => {
    return (
        <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            radius="sm"
            style={{ background: 'black' }}
        >
            <Spinner size="l" />
        </Box>
    );
};
